import { defineStore } from 'pinia'

// 定义应用状态存储
export const useAppStore = defineStore('app', {
  // 状态
  state: () => ({
    platformConfig: {},
    isDarkMode: false,
    appSettings: {
      theme: 'default',
      language: 'zh-CN'
    }
  }),
  
  // 计算属性
  getters: {
    getPlatformConfig: (state) => state.platformConfig,
    getTheme: (state) => state.appSettings.theme,
    getLanguage: (state) => state.appSettings.language
  },
  
  // 动作
  actions: {
    // 设置平台配置
    setPlatformConfig(config) {
      this.platformConfig = config
    },
    
    // 设置语言
    setLanguage(lang) {
      this.appSettings.language = lang
    },
    
    // 切换暗黑模式
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode
      // 应用暗黑模式到DOM
      if (this.isDarkMode) {
        document.documentElement.classList.add('dark-mode')
      } else {
        document.documentElement.classList.remove('dark-mode')
      }
    },
    
    // 设置主题
    setTheme(theme) {
      this.appSettings.theme = theme
      // 可以在这里添加主题切换的逻辑
    }
  },
  
  // 持久化配置
  persist: {
    key: 'app-store',
    storage: localStorage,
    paths: ['isDarkMode', 'appSettings']  // 只持久化这些字段
  }
}) 